import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftSelect from 'components/SoftSelect';
import axios from 'axios';

const ProviderSelector = ({ clientId, selectedProvider, setSelectedProvider }) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchProviders = async () => {
      setIsLoading(true);
      try {
        // Construimos el objeto "params" solo si clientId existe
        const params = clientId
          ? { id_cliente: clientId }
          : {};

        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/api/maintenance/providers/`,
          { params }
        );

        // La respuesta puede venir en dos formatos:
        // - si devolvimos una lista de providers directamente => response.data es Array
        // - si devolvimos { providers: [...] } => response.data.providers
        const providersArray = Array.isArray(response.data)
          ? response.data
          : response.data.providers || [];

        const newOptions = providersArray.map((prov) => ({
          label: prov.nombre,
          value: prov.id_proveedor,
        }));

        setOptions(newOptions);
      } catch (error) {
        console.error('Error fetching providers:', error);
        setOptions([]); // en caso de error, dejamos lista vacía
      } finally {
        setIsLoading(false);
      }
    };

    fetchProviders();
  }, [clientId]); // <-- SOLO clientId en el array de dependencias

  return (
    <SoftBox>
      <SoftTypography variant="caption" fontWeight="bold" color="text">
        Proveedor
      </SoftTypography>
      <SoftSelect
        options={options}
        placeholder="Seleccione un proveedor"
        isLoading={isLoading}
        // Buscamos el objeto cuyo .value coincida con selectedProvider (número)
        value={options.find((opt) => opt.value === selectedProvider) || null}
        onChange={(selectedOption) =>
          setSelectedProvider(selectedOption ? selectedOption.value : '')
        }
      />
    </SoftBox>
  );
};

ProviderSelector.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedProvider: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedProvider: PropTypes.func.isRequired,
};

ProviderSelector.defaultProps = {
  clientId: '',
  selectedProvider: '',
};

export default ProviderSelector;
